import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CasesService {

  baseUrl = environment.baseUrl;
  newCaseId: any;
  printerFunctioning = [
    { label: "Printing", value: "Printing", active: false },
    { label: "Printing with difficulties", value: "Printing with difficulties", active: false },
    { label: "Printer is down", value: "Printer is down", active: false }
  ]
  caseTypeList = [
    { label: "Break & Fix", value: "Break & Fix", id: "001" },
    { label: "Maintenance", value: "Maintenance", id: "002"  },
    { label: "Other", value: "Other", id: "003"  }
  ]
  steps = [
    {
      step: 1,
      stepValue: 'ADD_CASE.STEP_1',
      completed: false,
      active: true
    },
    {
      step: 2,
      stepValue: 'ADD_CASE.STEP_2',
      completed: false,
      active: false
    }
  ]
  stepsCutter = [
    
    {
      step: 1,
      stepValue: 'DEVICE_INFO',
      completed: false,
      active: false
    },
    {
      step: 2,
      stepValue: 'ADD_CASE.STEP_2',
      completed: false,
      active: false
    }
  ]


  constructor(private http: HttpClient) { }
  getCases() {
    return this.http.get<any>(this.baseUrl + '/services/case/api/v1/hp_cases')
  }

  getCasesList(page,limit) {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('limit', limit);
    return this.http.get<any>(this.baseUrl + `/services/case/api/v1/hp_cases`, {params})
  }

  getPrinters() {
    return this.http.get<any>(this.baseUrl + '/services/core/users/api/v1/printers?is_case=true')
  }

  getAssignees() {
    return this.http.get<any>(this.baseUrl + '/services/core/users/api/v1/reseller/users')
  }

  getContact(cust_id) {
    return this.http.get<any>(this.baseUrl + '/services/core/users/api/v1/customer_contacts?customer_organization_id=' + cust_id)
  }

  saveContact(body){
    return this.http.post<any>(this.baseUrl + '/services/core/api/mobile/v1/customer_contacts',body)

  }

  changeContact(custId,id){
    return this.http.put<any>(this.baseUrl+`/services/case/api/v1/update_case_contact?customer_contact_id=${custId}&id=${id}`,'')
  }

  getAlertsInfo(model, serial_number) {
    return this.http.get<any>(this.baseUrl + '/services/seals/api/v1/printers/printer_latest_alerts?product_number=' + model + '&serial_number=' + serial_number)
  }

  getServiceMaintenance(model, serial_number) {
    // return this.http.get<any>(this.baseUrl + '/services/seals/api/v1/printers/service_maintenances?product_number=' + model + '&serial_number=' + serial_number)
    return this.http.get<any>(this.baseUrl + '/services/seals/api/v1/actions?product_number=' + model + '&serial_number=' + serial_number)
  }

  createCase(body) {
    return this.http.post<any>(this.baseUrl + '/services/case/api/v1/hp_cases', body)
  }

  getUserRoles(){
    return this.http.get<any>(this.baseUrl + '/services/core/users/api/v1/job_titles')
  }

  createCustomerContact(body){
    return this.http.post<any>(this.baseUrl + '/services/core/users/api/v1/customer_contacts', body)
  }
}
